import IconSinister from '@mercadoni/sinister/dist/cjs/Icon'

const IconLogic = ({
  icon,
  onClick,
}: {
  icon: string
  onClick: () => void
}) => {
  const style = {
    marginRight: 'var(--spacing-margin-xSmall)',
    flexShrink: '0',
  }

  return (
    <IconSinister
      size={20}
      color="var(--more-about-icon-color,#000000)"
      className={icon}
      style={style}
      onClick={onClick}
    />
  )
}

const Icon = (props: { icon: string; onClick: () => void }) => (
  <IconLogic {...props} />
)

export default Icon
